export enum __FONT_FAMILIES {
  HEADING = "Lato",
  BODY = "Raleway",
}
